import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'src/components/ui/table';
import { Client } from '../../types/client.types';
import ManageClientsTableRow from './manage-clients-table-row';
import { Skeleton } from 'src/components/ui/skeleton';

interface ManageClientsTableProps {
  clients: Client[];
  className?: string;
  isCreation?: boolean;
  loading?: boolean;
  onClientSelect: (client: Client) => void;
}

const ManageClientsTable: React.FC<ManageClientsTableProps> = ({
  className,
  clients,
  isCreation,
  loading,
  onClientSelect,
}) => {
  return (
    <div className={`w-full ${className} overflow-visible`}>
      <Table className='overflow-visible'>
        <TableHeader className="sticky top-0 bg-white z-10 rounded-t-lg">
          <TableRow className="border-b border-gray-201 rounded-t-lg">
            <TableHead className='w-[3%] min-w-[30px] py-1.5' />
            <TableHead className="text-gray-600 py-1.5 w-[30%] min-w-[200px]">
              Client
            </TableHead>
            <TableHead className="text-gray-600 py-1.5 w-[20%] min-w-[150px]">
              Users
            </TableHead>
            <TableHead className="text-gray-600 py-1.5 w-[20%] min-w-[150px]">
              Accounts
            </TableHead>
            <TableHead className="text-gray-600 py-1.5 w-[30%] min-w-[200px]">
              Campaigns
            </TableHead>
            <TableHead className="text-gray-600 py-1.5 w-[30%] min-w-[200px]">
              Details
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody className="rounded-lg overflow-visible">
          {loading ? (
            Array.from({ length: 10 }).map((_, index) => (
              <TableRow key={index}>
                <TableCell
                  colSpan={6}
                  className='p-2 text-center'
                >
                  <Skeleton className='h-10 w-full' />
                </TableCell>
              </TableRow>
            ))
          ) : (
            clients.map((client) => (
              <ManageClientsTableRow
                client={client}
                isCreation={isCreation}
                key={client.ext_client_id}
                onClientSelect={onClientSelect}
              />
            )))}
        </TableBody>
      </Table>
    </div>
  );
};

export default ManageClientsTable;
